import React from 'react'

export const PlayIcon = (props) => (
    <svg style={props.style} width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6128 10.3292L0.918794 20.5448L0.918795 0.113567L18.6128 10.3292Z" fill={props.fill ? props.fill : "#676767"}/>
    </svg>    
)
